import { CardGrid } from '../../components/CardGrid';
import { ItemCard } from '../../components/ItemCard';
import { PageHeading } from '../../components/PageHeading';
import { PageSection } from '../../components/Section';
import type { HomeTemplateProps } from './HomeTemplate.types';

export function HomeTemplate({
  heading = 'What are you looking for?',
  categories,
  onSelectCategory,
  noImageLabel,
}: HomeTemplateProps) {
  return (
    <PageSection>
      <PageHeading title={heading} />
      <CardGrid $mobileColumns={2}>
        {categories.map((cat) => (
          <ItemCard
            key={cat.id}
            image={{
              src: cat.imageUrl || undefined,
              alt: cat.label,
              placeholderLabel: noImageLabel,
            }}
            imageAspectRatio="16 / 9"
            textPosition="center"
            title={cat.label}
            ariaLabel={cat.label}
            onSelect={() => onSelectCategory(cat.id)}
            boldTitle
          />
        ))}
      </CardGrid>
    </PageSection>
  );
}
